import { get } from 'lib/storage/isomorphicLocalStorage'

export const RECENTLY_VIEWED_MERCHANDISE_KEY = 'recentlyViewedMerchandise'

function getRecentlyViewedMerchandise(): Promise<Array<string>> {
  const merchandiseIds = get(RECENTLY_VIEWED_MERCHANDISE_KEY) ?? []
  return Promise.resolve(merchandiseIds)
}

export default getRecentlyViewedMerchandise
